export enum CountriesIso {
  Italy = 'IT',
  UnitedKingdom = 'GB',
  Egypt = 'EG',
  UAE = 'AE'
}
